"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TournamentSignUpEntryTableItem = /** @class */ (function () {
    function TournamentSignUpEntryTableItem() {
    }
    return TournamentSignUpEntryTableItem;
}());
exports.default = TournamentSignUpEntryTableItem;
